module.exports = __webpack_public_path__ + "static/media/download-asset.146438ff.png";